export default __webpack_public_path__ + "static/media/learn-card-2.0b7736c4.png";